import { useState } from "react";
// components
import ForgotPwdSuccess from "./ForgotPwdSuccess";
import FormForgotPwd from "./FormForgotPwd";
import AuthShell, { AuthHeading } from "../../../components/layout/AuthShell";

const ForgotPassword = () => {
    const [forgotPwdSuccess, setForgotPwdSuccess] = useState(false);

    return (
        <AuthShell>
            <AuthHeading />
            <div className="mt-6">
                { forgotPwdSuccess ?
                    <ForgotPwdSuccess />
                :
                    <FormForgotPwd setForgotPwdSuccess={ setForgotPwdSuccess } />
                }
            </div>
        </AuthShell>
    );
}

export default ForgotPassword;
